
import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Esemplare } from "../types"
import { API_URL } from "../constants"

export function useEsemplariList(params: Record<string, string> = {}) {
  return useList<Esemplare>(`${API_URL}/admin/esemplari`, {
    query: params,
  })
}


export function useEsemplare(id: number | undefined) {
  return useDetail<Esemplare>(`${API_URL}/admin/esemplari`, id?.toString())
}

export function useEsemplareCreate() {
  return useCreate<Esemplare>(`${API_URL}/admin/esemplari`)
}

export function useEsemplareUpdate() {
  return useUpdate<Esemplare>(`${API_URL}/admin/esemplari`)
}

export function useEsemplareDelete() {
  return useDelete<Esemplare>(`${API_URL}/admin/esemplari`)
}